import gql from 'graphql-tag'

export const SET_PHONEBOOKENTRY = gql`
    mutation setPhonebookentry($input: PhoneBookEntryInput!) {
        setPhoneBookEntry(input: $input)
    }
`
